<fieldset class="fieldGroup">
  <legend>{{ title() }}</legend>
  <div class="detailRow">
    <label class="displayLabel">Dry Bulb:</label>
    <label class="displayValue">{{ coilRequest().EnteringDryBulb }}</label>
    <label class="configurationRatingUnitLabel">{{ getTemperatureUnits() }}</label>
  </div>
  @if (coilRequest().EnteringWetBulb) {
    <div class="detailRow">
      <label class="displayLabel">Wet Bulb:</label>
      <label class="displayValue">{{ coilRequest().EnteringWetBulb }}</label>
      <label class="configurationRatingUnitLabel">{{ getTemperatureUnits() }}</label>
    </div>
  }
  @if (coilRequest().RowCount) {
    <div class="detailRow">
      <label class="displayLabel">Row Count:</label>
      <label class="displayValue">{{ coilRequest().RowCount }}</label>
    </div>
  }
  @if (coilRequest().TemperatureChange) {
    <div class="detailRow">
      <label class="displayLabel">Temp Change:</label>
      <label class="displayValue">{{ coilRequest().TemperatureChange }}</label>
      <label class="configurationRatingUnitLabel">{{ getTemperatureUnits() }}</label>
    </div>
  }
  @if (coilRequest().FlowRate) {
    <div class="detailRow">
      <label class="displayLabel">Flow Rate:</label>
      <label class="displayValue">{{ coilRequest().FlowRate }}</label>
      <label class="configurationRatingUnitLabel">{{ getFlowRateUnits() }}</label>
    </div>
  }
  @if (coilRequest().FluidType) {
    <div class="detailRow">
      <label class="displayLabel">Fluid Type:</label>
      <label class="displayValue">{{ coilRequest().FluidType }}</label>
    </div>
  }
  @if (coilRequest().EnteringFluidTemperature) {
    <div class="detailRow">
      <label class="displayLabel">Fluid Temp:</label>
      <label class="displayValue">{{ coilRequest().EnteringFluidTemperature }}</label>
      <label class="configurationRatingUnitLabel">{{ getTemperatureUnits() }}</label>
    </div>
  }
  @if (coilRequest().ElectricHeatKilowatts) {
    <div class="detailRow">
      <label class="displayLabel">E-Heat KW:</label>
      <label class="displayValue">{{ coilRequest().ElectricHeatKilowatts }}</label>
    </div>
  }
  @if (coilRequest().ElectricHeatVoltage) {
    <div class="detailRow">
      <label class="displayLabel">E-Heat Voltage:</label>
      <label class="displayValue">{{ coilRequest().ElectricHeatVoltage }}</label>
    </div>
  }
  @if (coilRequest().GlycolPercentage) {
    <div class="detailRow">
      <label class="displayLabel">Glycol %:</label>
      <label class="displayValue">{{ coilRequest().GlycolPercentage }}</label>
    </div>
  }
</fieldset>
